import { render, staticRenderFns } from "./shared-switch.vue?vue&type=template&id=6d65669b"
import script from "./shared-switch.vue?vue&type=script&lang=js"
export * from "./shared-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports